import { useEffect } from "react";
import { CryptoContext, useProvideCrypto } from "../../../hooks/CryptoHooks";

const ProvideCrypto = ({ children }) => {
  const crypto = useProvideCrypto();

  // Exponer el contexto globalmente para funciones que no pueden usar hooks
  useEffect(() => {
    window.__cryptoContext = crypto;
    return () => {
      delete window.__cryptoContext;
    };
  }, [crypto]);

  return <CryptoContext.Provider value={crypto}>{children}</CryptoContext.Provider>;
};

export default ProvideCrypto;
